<template>
  <div>
    <label>{{ requisite.title }}</label>
    <p>
      <input
        type="file"
        name="image_url"
        :disabled="uploading"
        accept="image/*, application/pdf"
        @change="uploadFile"
      >
      <img
        v-if="uploading"
        :src="require('@/assets/loading.gif')"
        width="32"
      >
      <a
        v-if="requisite.filePath"
        style="margin-left:15px"
        :href="requisite.filePath"
        target="_blank"
      ><v-btn
        color="blue"
        dark
        fab
        small
      ><v-icon dark>cloud_download</v-icon></v-btn></a>
    </p>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'AppUploadFile',
  props: {
    requisite: {
      required: true, type: Object
    }
  },
  data () {
    return {
      downloadAvailable: false,
      uploading: false
    }
  },
  methods: {
    ...mapActions({
      cargarArchivo: 'admision/cargarArchivo'
    }),
    async uploadFile (event) {
      try {
        const file = event.target.files[0]
        var formData = new FormData()
        formData.append('file', file)
        this.uploading = true
        const res = await this.cargarArchivo({ data: formData })
        this.uploading = false
        this.requisite.filePath = res.data.file_path
        this.requisite.url = res.data.file_url
        this.$emit('changed', { url: this.requisite.url, filePath: this.requisite.filePath })
      } catch (error) {
        this.uploading = false
        this.$message.error('Error al subir el archivo')
      }
    },
    validForm () {
      return !!this.requisite.filePath
    }
  }
}
</script>
